$(document).ready(function(){

if($(window).width()<940){

  
var rsheight = 0;
var MaxHeight=0;
var slideCheck = 0;  
clearTimeout();
var width1 = $(window).width()*0.95;  
var Slides = parseInt($(".review-slider.mobile ul li").length);
var ulwidth = Slides*width1;
$(".review-slider.mobile ul li").css("width",width1+"px");  
$(".review-slider.mobile ul").css("width",ulwidth+"px");
setTimeout(function() {
  
  $(".review-slider.mobile ul li").each(function(){
  	MaxHeight= $(this).children(".slide-item").height();
    if(MaxHeight > rsheight){
  		$(".review-slider.mobile").css("height",MaxHeight+20+"px");
    	rsheight = MaxHeight;
    }
  });  
  
},300);
  
$(".slider-navigation a.next").click(function(e){
  e.preventDefault();
  slideCheck++;
  if(slideCheck < Slides){
    $(".review-slider ul").animate({
      left: '-='+width1							   
    });
  } else {
   slideCheck = Slides-1; 
  }

});
                                     
$(".slider-navigation a.pre").click(function(e){
  e.preventDefault();
  slideCheck--;
  if(slideCheck > -1){
    $(".review-slider ul").animate({
      left: '+='+width1							   
    });
  } else {
   slideCheck = 0; 
  }
});                                     
  
  
} else {
  
var rsheight = 0;
var MaxHeight=0;
  
setTimeout(function() {  
  MaxHeight= $("li.active .slide-item").height();
  $(".review-slider.desktop").css("height",MaxHeight+"px");
},200);
clearTimeout();

    var width1 = $(window).width()*0.24;
    var width2 = $(window).width()*0.48;

  
$(".review-slider.desktop ul li:nth-child(3)").addClass("active");

$(".review-slider.desktop ul li").css("width",width1+"px");
$(".review-slider.desktop ul li.active").css("width",width2+"px");
						   
var Slides = parseInt($(".review-slider.desktop ul li").length);

var ulwidth = (Slides*width1)+width2;

$(".review-slider.desktop ul").css("width",ulwidth+"px");
$(".review-slider.desktop ul").css("left",((-1*width1)-10)+"px");

var ActiveSlide=3;
$(".slider-navigation a.next").click(function(e){
	  e.preventDefault();
	  if(ActiveSlide < Slides-1)
      {
			
			$(".review-slider.desktop ul").animate({
				left: '-='+width1							   
			});
			
			setTimeout(function() {
                    $(".review-slider.desktop ul li").removeClass(); 
					$(".review-slider.desktop ul li:nth-child("+(ActiveSlide+1)+")").addClass("active");
					$(".review-slider.desktop ul li").css("width",width1+"px");
					$(".review-slider.desktop ul li.active").css("width",width2+"px");
					ActiveSlide=ActiveSlide+1;
             }, 100);
        	 clearTimeout();
        	 setTimeout(function() {
              		MaxHeight = $("li.active .slide-item").height();
                    $(".review-slider.desktop").css("height",MaxHeight+"px");
             }, 300);
			
	  }

 
});
$(".slider-navigation a.pre").click(function(e){
      e.preventDefault();
      if(ActiveSlide > 2)
      { 

               $(".review-slider.desktop ul").animate({
                    left: '+='+width1							   
               });
               
        		setTimeout(function() {
                     $(".review-slider.desktop ul li").removeClass();
                     $(".review-slider.desktop ul li:nth-child("+(ActiveSlide-1)+")").addClass("active");
                     $(".review-slider.desktop ul li").css("width",width1+"px");
                     $(".review-slider.desktop ul li.active").css("width",width2+"px");
                     ActiveSlide=ActiveSlide-1;
                  
              }, 100);

      }
});

}

});
